const divLogin = {
  showError: 'Erro na requisição, se persistir, contate o suporte',
  showErrorConnection: 'Erro de conexão',
  showErrorManyRequests: 'Muitas tentativas consecutivas, tente novamente em instantes',
  showErrorPassword: 'Usuário ou senha incorretos',
  noAccess: 'Você não possui autorização, fale com seu administrador'
};

export default divLogin;
